import { NgModule } from '@angular/core'
import { SharedModule } from '../../../core/modules/shared.module'
import { RouterModule, Routes } from '@angular/router'

import { AuthGuard } from '../../authentication/auth.guard'
import { LedgerComponent } from './ledger.component'
import { AdministrationService } from '../../services/administration.service'
import { SettingsService } from '../../services/settings.service'
import { UserService } from '../../services/user.service'
import { AdminUsersComponent } from './admin-users/admin-users.component'
import { AdminBankAccountComponent } from './admin-bank-account/admin-bank-account.component'
import { AdminDocumentsComponent } from './admin-documents/admin-documents.component'
import { AdminTransactionsComponent } from './admin-transactions/admin-transactions.component'
import { AdminInvoicesComponent } from './admin-invoices/admin-invoices.component'
import { AdminUsersService } from './services/admin-users.service'
import { AdminUserListComponent } from './admin-users/admin-user-list/admin-user-list.component'
import { AdminUserDetailsComponent } from './admin-users/admin-user-details/admin-user-details.component'
import { AdminDocumentListComponent } from './admin-documents/admin-document-list/admin-document-list.component'
import { AdminDocumentDetailsComponent } from './admin-documents/admin-document-details/admin-document-details.component'
import { AdminDocumentImageComponent } from './admin-documents/admin-document-image/admin-document-image.component'
import { AdminDocumentsService } from './services/admin-documents.service'

const routes: Routes = [
  {
    path: 'ledger/:administrationId',
    component: LedgerComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'ledger',
    component: LedgerComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'ledger/:administrationId/users',
    component: LedgerComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'ledger/:administrationId/bank',
    component: LedgerComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'ledger/:administrationId/documents',
    component: LedgerComponent,
    canActivate: [AuthGuard],
  },
]

@NgModule({
  imports: [SharedModule, RouterModule.forChild(routes)],
  providers: [AdministrationService, SettingsService, UserService, AdminUsersService, AdminDocumentsService],
  declarations: [
    LedgerComponent,
    AdminUsersComponent,
    AdminBankAccountComponent,
    AdminDocumentsComponent,
    AdminTransactionsComponent,
    AdminInvoicesComponent,
    AdminUserListComponent,
    AdminUserDetailsComponent,
    AdminDocumentListComponent,
    AdminDocumentDetailsComponent,
    AdminDocumentImageComponent,
  ],
})
export class LedgerModule {}



// WEBPACK FOOTER //
// ./src/app/main/content/ledger/ledger.module.ts